export default {
  data() {
    return {
      translateX: 0,
      baseWidth: 380 + 30,
      maximumTranslate: 0,
    }
  },
  methods: {
    navGallery(diff) {
      const list = document.querySelector('.' + this.listClassName)
      if (!list) return

      this.maximumTranslate = this.getMaximumTranslate()

      if (this.maximumTranslate === 0) return

      let newValue = this.translateX + diff * this.baseWidth

      if (Math.abs(newValue) > this.maximumTranslate) {
        newValue =
          Math.abs(this.translateX) === this.maximumTranslate
            ? 0
            : -this.maximumTranslate
      } else if (newValue > 0) {
        newValue = 0
      }

      this.updateSelectorScroll(newValue)
    },

    getMaximumTranslate() {
      const list = document.querySelector('.' + this.listClassName)
      if (!list) return 0
      const scrollWidth = list.scrollWidth
      const clientWidth = list.clientWidth
      return Math.abs(scrollWidth - clientWidth)
    },

    updateSelectorScroll(newValue) {
      if (!newValue) newValue = 0
      this.translateX = newValue

      const list = document.querySelector('.' + this.listClassName)
      if (!list) return
      list.style.transform = `translate3d(${this.translateX}px, 0, 0)`
    },

    autoScrollToSelectedCategory({
      refName = 'categoriesContainer',
      isMobile = false,
      activeSelector = '.categories-filter__categories-item--active',
      offset = null,
    } = {}) {
      this.$nextTick(() => {
        const container = this.$refs[refName]
        if (!container) return

        const activeEl = container.querySelector(activeSelector)
        const fallbackOffset = isMobile ? 18 : 70
        const appliedOffset = offset !== null ? offset : fallbackOffset

        if (!activeEl) {
          this.translateX = 0
          if (!isMobile) {
            container.style.transform = `translate3d(0, 0, 0)`
          } else {
            container.scrollLeft = 0
          }
          return
        }

        const selectedCategoryLeft = activeEl.offsetLeft

        if (!isMobile) {
          let clientWidth = container.clientWidth || 0
          if (clientWidth > 1170) clientWidth = 1170

          const maxTranslateX = container.scrollWidth - clientWidth
          let newTranslate = Math.max(selectedCategoryLeft - appliedOffset, 0)
          newTranslate = Math.min(newTranslate, maxTranslateX)

          this.translateX = -newTranslate
          container.style.transform = `translate3d(${this.translateX}px, 0, 0)`
        } else {
          container.scrollLeft = selectedCategoryLeft - appliedOffset
        }
      })
    },
  },
}
